import React, {type ReactNode} from 'react';
import {useRouteMatch} from 'react-router-dom';

import {ARIA_PATH} from '../../routes/aria/ariaPaths';
import {WBAgent} from './WBAgent';
import {WBAgentChatButton} from './WBAgentChatButton';

const noop = () => undefined;

export const WBAgentActivePageButton = () => (
  <WBAgentChatButton
    aria-expanded
    disableTooltip
    isDisabled
    hideIntroTooltip={noop}
    unseenSettledThread={null}
  />
);

/**
 * Keeps the drawer runtime off the full-page ARIA route, where AriaPage owns
 * the runtime instead.
 */
export const WBAgentNav = ({children}: {children?: ReactNode}) => {
  const isAriaPage = useRouteMatch({path: ARIA_PATH, exact: true}) != null;
  return isAriaPage ? <WBAgentActivePageButton /> : (children ?? <WBAgent />);
};
